import React from 'react';
import { EDUCATION_OPTIONS } from '../../lib/calculator';

const SHORT = {
  noFormalEducation: '0',
  years1To4: '1–4',
  years5To8: '5–8',
  years9To11: '9–11',
  years12OrMore: '12+',
  none: 'Não informar',
};

/**
 * Escolaridade em uma linha de 6 chips curtos (anos de estudo), um radiogroup nativo.
 * O nome acessível de cada chip é o rótulo completo; as descrições longas ficam no tooltip (title)
 * e no details "Como escolher". Clicar de novo na opção marcada a desmarca.
 */
export default function EducationChips({ value, onChange, name = 'escolaridade', compact = false, legend = 'Escolaridade', hint = '(só muda a interpretação)' }) {
  return (
    <fieldset>
      <legend className="mb-2 text-[length:var(--fs-15)] font-semibold text-[var(--ink)]">
        {legend} <span className="font-normal text-[var(--ink-2)]">{hint}</span>
      </legend>
      <div className="grid grid-cols-6 gap-1 md:gap-1.5" role="presentation">
        {EDUCATION_OPTIONS.map((option) => {
          const selected = value === option.value;
          return (
            <label key={option.value} title={`${option.label}. ${option.exemplo}`} className="relative flex">
              <input
                type="radio"
                name={name}
                value={option.value}
                className="peer sr-only"
                checked={selected}
                onChange={() => onChange(option.value)}
                onClick={() => { if (selected) onChange(null); }}
                aria-label={`${SHORT[option.value]} — ${option.label}`}
              />
              <span
                aria-hidden="true"
                className={`flex min-h-11 w-full cursor-pointer select-none items-center justify-center rounded-[6px] border border-[var(--cell-border)] bg-[var(--surface)] px-0.5 text-center text-[length:var(--fs-13)] leading-tight md:px-1 md:text-[length:var(--fs-14)] font-medium text-[var(--ink)] transition-colors duration-[120ms] ease-out hover:bg-[var(--hover)] peer-checked:border-[var(--accent)] peer-checked:bg-[var(--accent-tint)] peer-checked:text-[var(--accent)] peer-checked:font-semibold peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-[var(--accent)]`}
              >
                {SHORT[option.value]}
              </span>
            </label>
          );
        })}
      </div>
      {!compact && <details className="mt-1">
        <summary className="inline-flex min-h-11 cursor-pointer items-center text-[length:var(--fs-14)] text-[var(--ink-2)] underline">Como escolher (anos de estudo)</summary>
        <ul className="grid gap-1 pb-2 text-[length:var(--fs-13)] text-[var(--ink-2)]">
          {EDUCATION_OPTIONS.map((option) => (
            <li key={option.value}><strong className="font-semibold text-[var(--ink)]">{SHORT[option.value]}</strong> — {option.label}. {option.exemplo}</li>
          ))}
        </ul>
      </details>}
    </fieldset>
  );
}
